import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {SpineUtils} from "../../utils/SpineUtils";

/**
 * Created by Jerker Nord on 2022-11-10.
 */

export class BenjiKIVFreeSpinIntroView extends PIXI.Container implements StageLayer {

    private static ANIMATION_NAME:string = "FS_Intro";

    private _clickCallback:Function;
    private _background:PIXI.Sprite;
    private _button:ContinueButton;
    private _fsIntroAnimation:PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "BenjiKIVFreeSpinIntroView";
        this.init();
    }

    private init():void {
        this.visible = false;

        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0;
        this.addChild(this._background);

        this._fsIntroAnimation = new PIXI.spine.Spine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.FS_INTROS_SPINE));
        this._fsIntroAnimation.position.set(360, 360);
        this._fsIntroAnimation.visible = false;
        this.addChild(this._fsIntroAnimation);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false)
        this._button.alpha = 0;
        this.addChild(this._button);

        this.onResize();
    }

    public showFSIntro(callback:Function):void {
        this.onResize();
        let startDelay:number = 1;
        if(BenjiKIV.model.isRestore) {
            startDelay = 0.2;
        }
        const showFSIntroTL:gsap.core.Timeline = gsap.timeline({delay : startDelay});
        showFSIntroTL.add(() => {
            this._clickCallback = callback;
            this._background.alpha = 0;
            this.visible = true;
            BenjiKIV.xBetView.hide();
        });
        showFSIntroTL.add([
            gsap.to(this._background, {duration : 0.4, alpha : 0.7}),
            gsap.to(this._button, {duration : 0.4, alpha : 1}),
            gsap.timeline({delay : 0}).add(() => {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.FS_AND_SFS_INTRO_START);
            }),
            gsap.timeline({delay : 0.234}).add(() => {
                BenjiKIV.soundPlayer.switchMusic(BenjiKIVSound.FS_INTRO_MUSIC);
            }),
            () => {this._fsIntroAnimation.visible = true},
            () => {this._fsIntroAnimation.alpha = 1},
            () => {SpineUtils.resetSpineAnimation(this._fsIntroAnimation)},
            () => {this._fsIntroAnimation.state.setAnimation(0, BenjiKIVFreeSpinIntroView.ANIMATION_NAME, false)}
        ]);
        showFSIntroTL.add(() => {
            this._button.enable(true);
        });
    }

    private onButtonClick():void {
        this._button.enable(false);
        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.CONTINUE_BUTTON);
        const hideFSIntroTL:gsap.core.Timeline = gsap.timeline();
        BenjiKIV.soundPlayer.switchMusic(BenjiKIV.model.data.nextMode);
        hideFSIntroTL.add(() => {
            if(BenjiKIV.model.isRestore) {
                BenjiKIV.keypadPlugin.setZeroBetSpinCounter(Math.max(BenjiKIV.model.freespinsLeft, 0));
            } else {
                BenjiKIV.keypadPlugin.setZeroBetSpinCounter(BenjiKIV.model.freespinsLeft);
            }
        });
        hideFSIntroTL.add([
            gsap.to(this._fsIntroAnimation, {duration : 0.1, alpha : 0}),
            gsap.to(this._button, {duration : 0.1, alpha : 0}),
            gsap.to(this._background, {duration : 0.2, alpha : 0}),
            BenjiKIV.keypadPlugin.show()
        ]);
        hideFSIntroTL.add(() => {this._fsIntroAnimation.visible = false});
        hideFSIntroTL.add(() => {SpineUtils.resetSpineAnimation(this._fsIntroAnimation)});
        hideFSIntroTL.add(() => BenjiKIV.backgroundElements.setMode(BenjiKIVGameMode.FREESPIN));
        //Small delay before FS starts
        hideFSIntroTL.add(gsap.timeline({delay : 0.2}));
        hideFSIntroTL.add(() => {
            this.visible = false;
            this._clickCallback();
        });
        hideFSIntroTL.add(() => {
        });
    }

    public onResize():void {
        const bounds:ScreenBounds = NolimitApplication.screenBounds;
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if(NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }
}